export default [
  { prop: 'data.event', header: 'Event' },
  { prop: 'data.artist', header: 'Artist' },
  { prop: 'data.venue', header: 'Venue' },
  { prop: 'data.likes', header: 'Likes' },
  { prop: 'data.rating', header: 'Rating' },
  { prop: 'data.raters', header: 'Raters' },
]
